import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <img src={'/me.jpg'} alt="Logo" width="250pt" style={{
      "cssFloat": "right"
    }} />
    <h1>{`Hi, I'm Shubhampreet Singh`}</h1>
    <p>{`I am an aspiring Data Analyst who loves to solve problems, visualize trends and make informed decisions using data. My Data Analytical Capstone project “The Virtual Cook” was ranked 2nd among 109 undergraduate projects from different universities across Alberta at “2021 Undergraduate Research in Science Conference of Alberta” (URSCA). I am an analytical thinker and drive insights using data regardless of the business environment I am working in. My continuous learning approach through various certifications has evolved me as a professional and a human.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      